"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardHeader = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

var _customProps = require("../../../../../../utils/customProps");

var _customComponents = require("../../../../../../utils/customComponents");

/* istanbul ignore next */
var Icon = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/atoms/Icon/Icon"));
  });
});
/* istanbul ignore next */

var IconButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonDownload/IconButtonDownload"));
  });
});
/* istanbul ignore next */

var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
});
/* istanbul ignore next */

var IconButtonDialog = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/templates/IconButtonDialog/IconButtonDialog"));
  });
});
var components = {
  Icon: Icon,
  IconButtonDownload: IconButtonDownload,
  IconButtonRedirect: IconButtonRedirect,
  IconButtonDialog: IconButtonDialog
};
/**
 * CardHeader is used in storyblok
 */

var CardHeader = function CardHeader(_ref) {
  var rootClass = _ref.rootClass,
      subheader = _ref.subheader,
      title = _ref.title,
      action = _ref.action,
      avatar = _ref.avatar,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid,
      storyblokClass = _ref.storyblokClass;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var muiavatar = avatar[0];
  var muiaction = action[0];
  return /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
    className: "".concat(styles.root, " ").concat(storyblokClass),
    title: title,
    subheader: subheader,
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid,
    avatar: muiavatar ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, (0, _customComponents.renderComponentsWithBridge)(components, muiavatar)) : null,
    action: muiaction ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, (0, _customComponents.renderComponentsWithBridge)(components, muiaction)) : null
  });
};

exports.CardHeader = CardHeader;
var _default = CardHeader;
exports.default = _default;
CardHeader.propTypes = {
  /**
   * The content of the Card Title.
   */
  title: _propTypes.default.string.isRequired,

  /**
   * subheader.
  */
  subheader: _propTypes.default.string,

  /**
   * MuiIconButtonRedirect, MuiIconButtonHref, MuiIconButtonDownload, MuiIconButtonDialog, GoogleConversion
   * Allowed maximum: 1
   * The action to display in the card header.
   * */
  action: function action(props, propName, componentName) {
    var comps = ['Icon'];
    return (0, _customProps.validComponents)(props, propName, componentName, comps, 1);
  },

  /**
   * MuiIconButtonRedirect, MuiIconButtonHref, MuiIconButtonDownload, MuiIconButtonDialog, GoogleConversion
   * Allowed maximum: 1
   * The Avatar for the Card Header.
   * */
  avatar: function avatar(props, propName, componentName) {
    var comps = ['Icon'];
    return (0, _customProps.validComponents)(props, propName, componentName, comps, 1);
  },

  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
CardHeader.defaultProps = {
  action: [],
  avatar: [],
  rootClass: [],
  subheader: '',
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};